import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=0030ddc6&scoped=true&slot-scope=scope&"
import script from "./Profession.vue?vue&type=script&lang=js&"
export * from "./Profession.vue?vue&type=script&lang=js&"
import style0 from "./Profession.vue?vue&type=style&index=0&id=0030ddc6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030ddc6",
  null
  
)

export default component.exports